import * as React from 'react';
import { useState } from 'react';
import { type Theme, useStyletron } from 'baseui';
import { HexColorInput } from './hex-color-input';
import { PresetColorGrid } from './preset-color-grid';
const HEX_REGEX = /^#[0-9a-fA-F]{6}$/;
type ColorPickerPopoverPropsT = {
  selectedColor: string;
  onColorChange: (color: string) => void;
  children: React.ReactNode;
};
const getWrapperStyles = () => ({
  position: ('relative' as const),
  display: ('inline-flex' as const)
});
const getDropdownStyles = (theme: Theme) => ({
  position: ('absolute' as const),
  top: '100%',
  left: theme.sizing.scale600,
  marginTop: theme.sizing.scale100,
  padding: theme.sizing.scale600,
  display: ('flex' as const),
  flexDirection: ('column' as const),
  backgroundColor: theme.colors.backgroundPrimary,
  borderRadius: theme.borders.radius300,
  boxShadow: theme.lighting.shadow600,
  zIndex: 1
});
const getLabelStyles = (theme: Theme) => ({
  ...theme.typography.LabelXSmall,
  color: theme.colors.contentSecondary,
  marginBottom: theme.sizing.scale200
});
const getSectionStyles = (theme: Theme) => ({
  marginTop: theme.sizing.scale500
});
export function ColorPickerPopover({
  selectedColor,
  onColorChange,
  children
}: ColorPickerPopoverPropsT) {
  const [css, theme] = useStyletron();
  const [isOpen, setIsOpen] = useState(false);
  const [hexInput, setHexInput] = useState(selectedColor);
  const close = () => setIsOpen(false);
  const handleToggle = () => {
    if (!isOpen) setHexInput(selectedColor);
    setIsOpen(!isOpen);
  };
  const handleSelect = (color: string) => {
    onColorChange(color);
    close();
  };
  const handleHexSubmit = () => {
    if (HEX_REGEX.test(hexInput)) {
      onColorChange(hexInput);
      close();
    }
  };
  return <div className={css(getWrapperStyles())}>
      <div onClick={handleToggle}>{children}</div>

      {isOpen && <>
          <div onClick={close} style={{
        position: 'fixed',
        inset: 0
      }} />
          <div className={css(getDropdownStyles(theme))} data-testid="color-picker-popover">
            <div className={css(getLabelStyles(theme))}>Preset colors</div>
            <PresetColorGrid selectedColor={selectedColor} onSelect={handleSelect} />

            <div className={css(getSectionStyles(theme))}>
              <div className={css(getLabelStyles(theme))}>Custom hex</div>
              <HexColorInput value={hexInput} fallbackColor={selectedColor} onChange={setHexInput} onSubmit={handleHexSubmit} />
            </div>
          </div>
        </>}
    </div>;
}